import { ShepherdStep } from "../shepherdTour/ShepherdTour";

const SHEPHERD_BUTTON_SECONDARY = "shepherd-button-secondary";

export const guidedTourSteps: Array<ShepherdStep> = [
  {
    id: "intro1",
    arrow: false,
    attachTo: { on: "bottom" },
    buttons: [
      {
        classes: SHEPHERD_BUTTON_SECONDARY,
        text: "Stop rondleiding",
        type: "cancel",
      },
      {
        text: "Start rondleiding",
        type: "next",
      },
    ],
    scrollTo: true,
    title: "Welkom in het DELA Portaal",
    text: "Volg een korte rondleiding zodat je weet waar je premies berekent, lopende zaken of dossier in kan zien. Neem bij vragen contact op met je account- of klantmanager. Je kunt natuurlijk altijd bellen met de collega’s van relatiebeheer via 040 - 260 14 44.",
  },

  {
    id: "intro2",
    arrow: false,
    attachTo: { element: "#username", on: "bottom" },
    popperOptions: {
      modifiers: [{ name: "offset", options: { offset: [0, 20] } }],
    },
    buttons: [
      {
        classes: SHEPHERD_BUTTON_SECONDARY,
        text: "Terug",
        type: "back",
      },
      {
        text: "Verder",
        type: "next",
      },
    ],
    scrollTo: true,
    scrollToHandler: () => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    title: "Accountnaam",
    text: "Je kunt hier zien of je met het juiste account bent ingelogd.",
  },
  {
    id: "intro3",
    arrow: false,
    attachTo: { element: "#sidebar_button_0", on: "right" },
    popperOptions: {
      modifiers: [{ name: "offset", options: { offset: [0, 12] } }],
    },
    buttons: [
      {
        classes: SHEPHERD_BUTTON_SECONDARY,
        text: "Terug",
        type: "back",
      },
      {
        text: "Verder",
        type: "next",
      },
    ],
    scrollTo: true,
    scrollToHandler: () => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    cancelIcon: {
      enabled: true,
    },
    title: "Start een nieuwe berekening",
    text: "Maak voor je klanten een berekening voor de gewenste verzekering",
  },
  {
    id: "intro4",
    arrow: false,
    attachTo: { element: "#sidebar_button_1", on: "right" },
    popperOptions: {
      modifiers: [{ name: "offset", options: { offset: [0, 12] } }],
    },
    buttons: [
      {
        classes: SHEPHERD_BUTTON_SECONDARY,
        text: "Terug",
        type: "back",
      },
      {
        text: "Verder",
        type: "next",
      },
    ],
    scrollTo: true,
    scrollToHandler: () => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    title: "Lopende zaken",
    text: "Heb je een berekening gemaakt en wil je daarmee verder? Wij hebben deze hier voor je bewaard.",
  },
  {
    id: "intro5",
    arrow: false,
    attachTo: { element: "#sidebar_button_2", on: "right" },
    popperOptions: {
      modifiers: [{ name: "offset", options: { offset: [0, 12] } }],
    },
    buttons: [
      {
        classes: SHEPHERD_BUTTON_SECONDARY,
        text: "Terug",
        type: "back",
      },
      {
        text: "Verder",
        type: "next",
      },
    ],
    scrollTo: true,
    scrollToHandler: () => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    title: "Polissen inzien",
    text: "Bekijk hier alle polissen van jouw klanten.",
  },

  {
    id: "intro6",
    arrow: false,
    attachTo: { element: "#richtext_id", on: "top-start" },
    scrollTo: true,
    buttons: [
      {
        classes: SHEPHERD_BUTTON_SECONDARY,
        text: "Terug",
        type: "back",
      },
      {
        text: "Verder",
        type: "next",
      },
    ],
    title: "Zo ben je up-to-date",
    text: "We blijven het DELAPortaal verbeteren. Hier lees je terug welke verbeteringen we hebben doorgevoerd.",
  },
  {
    id: "intro7",
    arrow: false,
    attachTo: { element: "#product_list", on: "top" },
    popperOptions: {
      modifiers: [{ name: "offset", options: { offset: [0, 12] } }],
    },
    buttons: [
      {
        classes: SHEPHERD_BUTTON_SECONDARY,
        text: "Terug",
        type: "back",
      },
      {
        text: "Klaar",
        type: "next",
      },
    ],
    scrollTo: { block: "end" },
    title: "Start een berekening",
    text: "Kies het product waar je een berekening voor wilt uitvoeren.",
  },
];
